import React, { useEffect, useState } from 'react';
import { GoBackButton } from '@shared/ui/atoms/buttons/GoBackButton';
import { HeadlineLarge } from '@shared/ui/atoms/fonts/Headline';
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import TextField from '@shared/ui/atoms/TextField';
import { useDispatch } from "react-redux";
import { MIN_SEARCH_LENGTH, reloadUsers, setSearchQuery } from "../ducks/manage-users.duck";
import { IconTypes } from '@shared/ui/atoms/icon/Icon';
import Colours from '@shared/ui/atoms/Colours';
import { tablet } from '@shared/ui/atoms/MediaQueries';

export function ManageUsersHeader(props: Props) {
  const {t} = useTranslation();
  const [searchTerm, setSearchTerm] = useState('');
  const [hasChanged, setHasChanged] = useState(false);
  const dispatch = useDispatch();

  const onChange = (result: string) => {
    setSearchTerm(result);
    dispatch(setSearchQuery(result));
  }

  // Searching and clearing a search both stay within the selected filter
  const resetSearch = () => {
    onChange('');
    dispatch(reloadUsers({searchTerm: undefined, skip: 0}));
  }

  const onBlur = () => {
    if (hasChanged && searchTerm.length === 0) {
      setHasChanged(false);
      dispatch(reloadUsers({searchTerm: undefined, skip: 0}));
    }
  }

  useEffect(() => {
    if (searchTerm.length < MIN_SEARCH_LENGTH) return;

    setHasChanged(true);
    const id = setTimeout(() => {
      dispatch(reloadUsers({searchTerm: searchTerm, skip: 0}));
    }, 250);

    return () => {
      clearTimeout(id);
    }
  }, [searchTerm, dispatch]);

  return (
    <Wrapper>
      <GoBackButton />
      <HeaderRow>
        <HeadlineLarge>{t('manage-users-page.title')}</HeadlineLarge>
        <SearchBarWrapper>
          <TextField onChange={onChange}
                     icon={searchTerm.length > 0 ? IconTypes.Close : IconTypes.Search}
                     placeholder={'manage-users-page.search'}
                     onIconClick={searchTerm.length > 0 ? resetSearch : undefined}
                     onBlur={onBlur}
                     value={searchTerm} />
        </SearchBarWrapper>
      </HeaderRow>
    </Wrapper>
  )
}

interface Props {
}

const Wrapper = styled.div`
  margin: 0 16px;

  @media (${tablet}) {
    margin: 0;
  }
`

const HeaderRow = styled.div`
  display: flex;
  flex-direction: column;
  h1 {
    margin-bottom: 24px;
  }

  @media (${tablet}) {
    flex-direction: row;
    justify-content: space-between;
    h1 {
      margin-bottom: 0;
    }
  }
`

const SearchBarWrapper = styled.div`
  display: flex;
  input {
    width: 100%;
  }
  p {
    white-space: nowrap;
    color: ${Colours.darkGrey};
  }
  * {
    box-shadow: none !important;
  }

  @media (${tablet}) {
    margin-right: 16px;
    input {
      width: 300px;
    }
  }
`
